import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AddPaymentMethodModal = ({ isOpen, onClose, onAdd }) => {
  const [methodType, setMethodType] = useState('bank');
  const [formData, setFormData] = useState({
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    accountType: 'checking'
  });

  const accountTypes = [
    { value: 'checking', label: 'Checking Account' },
    { value: 'savings', label: 'Savings Account' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onAdd({
      type: methodType,
      ...formData
    });
    onClose();
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-[var(--color-card)] rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-[var(--color-card)] border-b border-[var(--color-border)] p-4 md:p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[var(--color-primary)] bg-opacity-10 flex items-center justify-center">
              <Icon name="Plus" size={20} color="var(--color-primary)" />
            </div>
            <h2 className="text-lg md:text-xl font-semibold text-[var(--color-foreground)]">
              Add Payment Method
            </h2>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            iconName="X"
            iconSize={20}
          />
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4">
          <div className="grid grid-cols-3 gap-2">
            <button
              type="button"
              onClick={() => setMethodType('bank')}
              className={`p-3 md:p-4 rounded-lg border-2 transition-all duration-300 ${
                methodType === 'bank' ?'border-[var(--color-primary)] bg-[var(--color-primary)] bg-opacity-10' :'border-[var(--color-border)] hover:border-[var(--color-primary)]'
              }`}
            >
              <Icon name="Building2" size={20} color={methodType === 'bank' ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} className="mx-auto" />
              <p className="text-xs mt-2 text-[var(--color-foreground)]">Bank</p>
            </button>
            
            <button
              type="button"
              onClick={() => setMethodType('card')}
              className={`p-3 md:p-4 rounded-lg border-2 transition-all duration-300 ${
                methodType === 'card' ?'border-[var(--color-primary)] bg-[var(--color-primary)] bg-opacity-10' :'border-[var(--color-border)] hover:border-[var(--color-primary)]'
              }`}
            >
              <Icon name="CreditCard" size={20} color={methodType === 'card' ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} className="mx-auto" />
              <p className="text-xs mt-2 text-[var(--color-foreground)]">Card</p>
            </button>
            
            <button
              type="button"
              onClick={() => setMethodType('wire')}
              className={`p-3 md:p-4 rounded-lg border-2 transition-all duration-300 ${
                methodType === 'wire' ?'border-[var(--color-primary)] bg-[var(--color-primary)] bg-opacity-10' :'border-[var(--color-border)] hover:border-[var(--color-primary)]'
              }`}
            >
              <Icon name="ArrowRightLeft" size={20} color={methodType === 'wire' ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} className="mx-auto" />
              <p className="text-xs mt-2 text-[var(--color-foreground)]">Wire</p>
            </button>
          </div>

          {methodType === 'bank' && (
            <>
              <Input
                label="Account Holder Name"
                type="text"
                placeholder="John Doe"
                value={formData?.accountName}
                onChange={(e) => handleChange('accountName', e?.target?.value)}
                required
              />

              <Input
                label="Account Number"
                type="text"
                placeholder="Enter account number"
                value={formData?.accountNumber}
                onChange={(e) => handleChange('accountNumber', e?.target?.value)}
                required
              />

              <Input
                label="Routing Number"
                type="text"
                placeholder="Enter routing number"
                value={formData?.routingNumber}
                onChange={(e) => handleChange('routingNumber', e?.target?.value)}
                required
              />

              <Select
                label="Account Type"
                options={accountTypes}
                value={formData?.accountType}
                onChange={(value) => handleChange('accountType', value)}
              />

              <div className="p-3 md:p-4 bg-[var(--color-muted)] rounded-lg">
                <div className="flex items-start gap-2">
                  <Icon name="Info" size={16} color="var(--color-muted-foreground)" className="mt-0.5 flex-shrink-0" />
                  <p className="text-xs text-[var(--color-muted-foreground)]">
                    We'll make two small deposits to verify your account. This process typically takes 1-2 business days.
                  </p>
                </div>
              </div>
            </>
          )}

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              fullWidth
            >
              Add Method
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPaymentMethodModal;